import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    ariaLabel: string;
    showMore: (count: number) => string | React.ReactNode;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Aria label for the workspace options menu button */
            ariaLabel: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "WorkspaceItem.ariaLabel?c=20ybj26k81yd3", defaultMessage: "More options" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Button text to show more projects */
            showMore: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (count: number) => __intl__.intl().formatMessage({ id: "WorkspaceItem.showMore?c=1vwza9qz22yvf", defaultMessage: "+{count} More" }, { count: count }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
